export function extend(destination, source) {
  Object.keys(source).forEach((key) => {
    destination[key] = source[key];
  });
}



// WEBPACK FOOTER //
// ./src/mixins/mixin.js